import { CommonInsightsReportHelp } from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/CommonComponents/CommonInsightViews";
import { CommonInsightsMeanTimeToRecoveryOverview } from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/CommonComponents/CommonInsightsMeanTimeToRecoveryViews";
export const InsightsReportMeanTimeToRecoveryHelp = () => (<>
        <CommonInsightsMeanTimeToRecoveryOverview /> <CommonInsightsReportHelp />
    </>);
